<template>
  <BaseCustomizeMetal componentCode="L" :useGodNameVerticalText="true" />
</template>

<script>
import BaseCustomizeMetal from "@/components/customizeMetal/traditionalMetal/BaseCustomizeMetal/index.vue";
export default {
  name: "CustomizeMetalL",
  components: {
    BaseCustomizeMetal,
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .metal-text {
    top: 45px;
    left: 153px;
    @include betweenTableTablePro {
      top: 14px;
      left: 103px;
    }
    @include table {
      top: -4px;
      left: 78px;
    }
    @include phone {
      top: -10px;
      left: 62px;
    }
  }
  .templeName {
    height: 33px;
    width: 189px;
    .textContainer {
      width: 189px;
    }
  }
  .godName {
    width: 111px;
    height: 131px;
    writing-mode: vertical-lr;
    writing-mode: vertical-rl;
    .textContainer {
      width: 111px;
      height: 131px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .gift {
    width: 79px;
    height: 33px;
    .textContainer {
      width: 79px;
    }
  }
}
</style>
